import React, { useContext, useState } from 'react';
import { ThemeContext } from '../context/themeContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSun, faMoon, faBars } from '@fortawesome/free-solid-svg-icons';
import useAuth from '../hooks/useAuth';
import { useNavigate } from 'react-router-dom';

const Sidebar = () => {
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const user = useAuth();
  const navigate = useNavigate();
  const { darkMode, toggleTheme } = useContext(ThemeContext);

  const toggleSidebar = () => setSidebarOpen(!isSidebarOpen);

  const imageUrl = user?.image
    ? `https://api.theonlysale.com/uploads/profile_pics/${user.image.split(/[\\/]/).pop()}`
    : "https://www.pngall.com/wp-content/uploads/5/Profile-PNG-File.png";

  const userName = user?.name || 'Guest';

  const handleLogout = () => {
    localStorage.removeItem('token');
    navigate('/');
  };

  return (
    <>
      {/* Mobile Sidebar Toggle Button */}
      <button
        aria-controls="default-sidebar"
        type="button"
        className="fixed top-4 left-4 z-50 inline-flex items-center p-2 text-gray-500 bg-white rounded-lg shadow-md sm:hidden dark:bg-gray-800 dark:text-gray-400"
        onClick={toggleSidebar}
      >
        <FontAwesomeIcon icon={faBars} size="lg" />
        <span className="sr-only">Open sidebar</span>
      </button>

      {/* Sidebar */}
      <aside
        id="default-sidebar"
        className={`fixed top-0 left-0 z-40 w-64 h-screen transition-transform bg-white border-r dark:bg-gray-800 dark:border-gray-700 ${
          isSidebarOpen ? 'translate-x-0' : '-translate-x-full'
        } sm:translate-x-0`}
        aria-label="Sidebar"
      >
        <div className="flex flex-col h-full py-5 px-4 overflow-y-auto">
          {/* User Profile Section */}
          <div className="flex flex-col items-center mb-6">
            <img
              src={imageUrl}
              alt="Profile"
              className="w-20 h-20 rounded-full border-2 border-gray-300 dark:border-gray-600"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "https://www.pngall.com/wp-content/uploads/5/Profile-PNG-File.png";
              }}
            />
            <span className="mt-2 text-lg font-semibold text-gray-900 dark:text-white">
              {userName}
            </span>
          </div>

          {/* Navigation Links */}
          <ul className="space-y-3">
            <li>
              <a
                href="/profile"
                className="flex items-center p-2 text-sm font-medium text-gray-700 rounded-lg hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-700"
              >
                <i className="fas fa-user fa-lg mr-3 text-gray-400"></i>
                Profile
              </a>
            </li>

            <li>
              <a
                href={
                  user?.role === 'superadmin'
                    ? "/superadmin"
                    : user?.role === 'admin'
                    ? "/super-admin"
                    : user?.role === 'business' || user?.role === 'premium'
                    ? "/admin"
                    : user?.role === 'delivery'
                    ? "/delivery"
                    : "/buyer"
                }
                className="flex items-center p-2 text-sm font-medium text-gray-700 rounded-lg hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-700"
              >
                <i className="fas fa-tachometer-alt fa-lg mr-3 text-gray-400"></i>
                Dashboard
              </a>
            </li>

            {/* Conditionally Render Orders Link for Delivery Role */}
            {user?.role === 'delivery' && (
              <li>
                <a
                  href="/dashboard/deliveries"
                  className="flex items-center p-2 text-sm font-medium text-gray-700 rounded-lg hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-700"
                >
                  <i className="fas fa-box fa-lg mr-3 text-gray-400"></i>
                  Orders
                </a>
              </li>
            )}

            {/* Conditionally Render Sales Link for Non-Delivery Roles */}
            {user?.role !== 'delivery' && user?.role !== 'user' && (
              <li>
                <a
                  href="/sales"
                  className="flex items-center p-2 text-sm font-medium text-gray-700 rounded-lg hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-700"
                >
                  <i className="fas fa-chart-line fa-lg mr-3 text-gray-400"></i>
                  Sales
                </a>
              </li>
            )}

            <li>
              <a
                href="/"
                className="flex items-center p-2 text-sm font-medium text-gray-700 rounded-lg hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-700"
              >
                <i className="fas fa-home fa-lg mr-3 text-gray-400"></i>
                Home
              </a>
            </li>

            <li>
              <button
                onClick={handleLogout}
                className="flex items-center w-full p-2 text-sm font-medium text-left text-gray-700 rounded-lg hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-700"
              >
                <i className="fas fa-sign-out-alt fa-lg mr-3 text-gray-400"></i>
                Log out
              </button>
            </li>
          </ul>

        
        </div>
      </aside>

      {/* Sidebar Overlay for Mobile */}
      {isSidebarOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-30 sm:hidden"
          onClick={toggleSidebar}
        ></div>
      )}
    </>
  );
};

export default Sidebar;
